/* eslint-disable no-param-reassign */

import api from '@/services/api/role/role';

export default {
  state: {
    missions: []
  },
  mutations: {
    SET_MISSIONS: (state, data) => {
      state.missions = data;
    },
  },
  getters: {},
  actions: {
    permissionsIndex({
      commit,
      state
    }, params) {
      return new Promise((resolve, reject) => {
        api.permissionsIndex(params).then((res) => {
          commit('SET_MISSIONS', res)
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    }
  }
};
